import React from "react";
import { useQuery } from "react-query";
import { getGuestList, getKeyList } from "../mutations/TransactionsMutation";
import Loader from "../../../components/Components/Loader";
import { Grid } from "@mui/material";
import EditableTable from "../../../components/Components/KeyTable";

function KeyTransaction() {
  const currentTimestamp = Date.now();

  const currentDate = new Date(currentTimestamp);

  const formattedDate = currentDate.toISOString().slice(0, 10);

  const { data: keyData, isLoading } = useQuery(
    "key-transactions",
    () => getKeyList(formattedDate),
    {
      refetchOnMount: true,
    }
  );

  console.log("key transaction");

  if (isLoading) return <Loader />;

  return (
    <Grid container justifyContent={"center"}>
      <Grid item textAlign={"center"}>
        <h4>Key Transactions</h4>
      </Grid>
      <Grid item xs={12}>
        <EditableTable tableData={keyData ?? []} />
      </Grid>
    </Grid>
  );
}

export default KeyTransaction;
